<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="会员设置" name="first"></el-tab-pane>
      <el-tab-pane label="会员升级记录" name="second"></el-tab-pane>
      <el-tab-pane label="会员申请记录" name="settled"></el-tab-pane>
    </el-tabs>

    <!--积分设置-->
    <Setting v-if="activeName == 'first'"></Setting>
    <!--积分明细-->
    <Log v-if="activeName == 'second'"></Log>
    <Settled v-if="activeName == 'settled'"></Settled>

  </div>
</template>
<script>
  import Setting from './part/Setting';
  import Log from './part/Log';
    import Settled from './part/Settled';
  export default {
    components: {
      Setting,
      Log,
      Settled
    },
    data() {
      return {
        form: {
          status: 0
        },
        activeName: 'first'
      };
    },
    methods: {}
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/setting/index.vue